import React from 'react';
import classNames from 'classnames';

import './Logo.less';
import {TrackingContext} from '@homeaway/react-event-tracking';
import {isEmpty} from '../../utils/string.utils';

export class Logo extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.handleClick = this.handleClick.bind(this);
        this.triggerPartnerEvent = this.triggerPartnerEvent.bind(this);
    }

    static contextType = TrackingContext;

    handleClick() {
        const field = {
            actionlocation: 'header.logo'
        };

        this.context.trigger('header.link.click', field);
    }

    triggerPartnerEvent() {
        const field = {
            actionlocation: 'partner.logo'
        };

        this.context.trigger('pageview', field);
    }

    get logoLink() {
        let {
            altText,
            hasSearch,
            image,
            link,
            text,
        } = this.props;

        if (this.props.partnerLogo && this.props.sitePartnerLogo) {
            image = this.props.sitePartnerLogo.image;
        }

        const className = classNames(
            'site-header-logo__link',
            'flex-item',
            {'has-search': hasSearch},
        );

        return (
            <a className={className} href={link} itemProp="url" title={text} onClick={this.handleClick}>
                <img alt={altText} className={`site-header-logo__img Header-BG img-responsive${this.props.partnerLogo ? ' site-logo' : ''}`} itemProp="logo" role="presentation" src={image}/>
            </a>
        );
    }

    /* istanbul ignore next */
    get partnerLogoLink() {
        if (!this.props.partnerLogo) {
            return null;
        }

        const {image, link, text} = this.props.partnerLogo;

        return (
            <a className="site-header-logo__link has-partner-divider hidden-xxs" href={link} title={text} onClick={this.handleClick} onLoad={this.triggerPartnerEvent}>
                <img alt="partner logo" className="site-header-logo__img affiliates-logo img-responsive" src={image} />
            </a>
        );
    }

    get partnershipText() {
        if (!this.props.partnerLogo) {
            return null;
        }

        const defaultPartnershipText = 'in partnership with';

        let {partnershipText} = this.props.partnerLogo;

        if (isEmpty(partnershipText)) {
            partnershipText = defaultPartnershipText;
        }

        const classNameHidden = classNames(
            'partnership-text',
            'hidden-sm',
            'hidden-xs'
        );
        const classNameVisible = classNames(
            'logo-divider',
            'visible-sm',
            'visible-xs'
        );

        return (
            <div className="logo-separator hidden-xxs">
                <div className={classNameHidden}> {partnershipText} </div>
                <div className={classNameVisible} />
            </div>
        );
    }

    render() {
        return (
            <div className="site-header-logo" itemScope="itemscope" itemType="https://schema.org/Organization">
                {this.logoLink}
                {this.partnershipText}
                {this.partnerLogoLink}
            </div>
        );
    }
}
